module.exports = __webpack_public_path__ + "img/jetpack.08eed338.svg";